import { NgModule } from "@angular/core";
import { FooterComponent } from "./footer.component";
import { CommonModule } from "@angular/common";
import { I18nModule, UrlModule } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, MediaModule } from "@spartacus/storefront";
import { CompareProductsComponent } from "./compare-products/compare-products.component";
import { RouterModule } from "@angular/router";
import { FooterPrivacyPolicyPopupComponent } from './footer-privacy-policy-popup/footer-privacy-policy-popup.component';
import { FooterTermsOfUsePopupComponent } from './footer-terms-of-use-popup/footer-terms-of-use-popup.component';
import { MatDialogModule } from "@angular/material/dialog";


@NgModule({
    imports: [
        CommonModule,
        PageLayoutModule,
        OutletModule,
        OutletRefModule,
        PageSlotModule,
        MediaModule,
        RouterModule,
        UrlModule,
        I18nModule,
        MatDialogModule
    ],
    providers: [],
    declarations: [FooterComponent, CompareProductsComponent, FooterPrivacyPolicyPopupComponent, FooterTermsOfUsePopupComponent]
})
export class FooterModule {

}
